"use client";

import { useMediaQuery, useTheme } from "@/components/controls/base-controls";

type ResponsiveImageSource = { src: string; width: number; height: number };

const useResponsiveImage = (
    xs: ResponsiveImageSource,
    sm: ResponsiveImageSource,
    md: ResponsiveImageSource,
    lg: ResponsiveImageSource,
    xl: ResponsiveImageSource,
): ResponsiveImageSource => {
    const theme = useTheme();
    const isXl = useMediaQuery(theme.breakpoints.up("xl"));
    const isLg = useMediaQuery(theme.breakpoints.up("lg"));
    const isMd = useMediaQuery(theme.breakpoints.up("md"));
    const isSm = useMediaQuery(theme.breakpoints.up("sm"));

    if (isXl) return xl;
    if (isLg) return lg;
    if (isMd) return md;
    if (isSm) return sm;
    return xs;
};

export default useResponsiveImage;
